import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config';
import { useFeature } from '../../../context/AuthContext';

/**
 * /api/tool_requests, fetched ONCE for the home page and shared by My requests
 * (the caller's own proposals) and To approve (proposals awaiting them). For a
 * full admin the endpoint returns every proposal in the org, so two fetches
 * would double the heaviest call on the page.
 *
 * status: 'off' (flag known off, or the server says feature_disabled) |
 *         'loading' | 'ready' | 'error'.
 */
export default function useToolRequests() {
  const on = useFeature('tool_proposal_approval');
  const [state, setState] = useState({ status: on ? 'loading' : 'off', rows: [] });
  const [attempt, setAttempt] = useState(0);
  const retry = useCallback(() => setAttempt((n) => n + 1), []);

  useEffect(() => {
    if (!on) { setState({ status: 'off', rows: [] }); return undefined; }
    let active = true;
    setState((s) => ({ ...s, status: 'loading' }));
    axios.get(`${API_BASE_URL}/api/tool_requests`, { withCredentials: true })
      .then((res) => { if (active) setState({ status: 'ready', rows: Array.isArray(res.data) ? res.data : [] }); })
      .catch((err) => {
        if (!active) return;
        const off = err?.response?.data?.error === 'feature_disabled';
        setState({ status: off ? 'off' : 'error', rows: [] });
      });
    return () => { active = false; };
  }, [on, attempt]);

  return { ...state, retry };
}
